/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Institution email matching requirements for tier access. We can match on email DOMAINS or individual email ADDRESSES.  NO_ACCESS indicates that the institution does not provide access to the tier at all, and UNINITIALIZED is for unsaved institutions in the admin UI.
 * @export
 */
export const InstitutionMembershipRequirement = {
    DOMAINS: 'DOMAINS',
    ADDRESSES: 'ADDRESSES',
    NO_ACCESS: 'NO_ACCESS',
    UNINITIALIZED: 'UNINITIALIZED'
} as const;
export type InstitutionMembershipRequirement = typeof InstitutionMembershipRequirement[keyof typeof InstitutionMembershipRequirement];


export function InstitutionMembershipRequirementFromJSON(json: any): InstitutionMembershipRequirement {
    return InstitutionMembershipRequirementFromJSONTyped(json, false);
}

export function InstitutionMembershipRequirementFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstitutionMembershipRequirement {
    return json as InstitutionMembershipRequirement;
}

export function InstitutionMembershipRequirementToJSON(value?: InstitutionMembershipRequirement | null): any {
    return value as any;
}

